import { Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

const RequeueEmailButton = (props) => {
  const { text, style, ...restProps } = props;
  return (
    <Button
      type='primary'
      style={{ borderRadius: '4px', ...style }}
      icon={<SaveOutlined />}
      {...restProps}
    >
      <span>{text || 'Requeue Email'}</span>
    </Button>
  );
}

export default RequeueEmailButton;
